<template>
  <section class="player-section">
    <div class="transport">
      <button id="btn-prev-track" title="Previous Track" :disabled="isLive || isBuffering" @click="skipToPrevTrack"><AppIcon name="step-backward" /></button>
      <button id="btn-skip-back" title="Back 30s" :disabled="isLive || isBuffering" @click="skipBack"><AppIcon name="backward" /></button>
      <button id="btn-play" title="Play/Pause" :disabled="isBuffering" @click="toggle">
        <AppIcon v-if="isBuffering" name="spinner" spin />
        <AppIcon v-else :name="isPlaying ? 'pause' : 'play'" />
      </button>
      <button id="btn-skip-forward" title="Forward 30s" :disabled="isLive || isBuffering" @click="skipForward"><AppIcon name="forward" /></button>
      <button id="btn-next-track" title="Next Track" :disabled="isLive || isBuffering" @click="skipToNextTrack"><AppIcon name="step-forward" /></button>
    </div>
    <div class="time-display">
      <span id="current-time">{{ currentTimeStr }}</span>
      <span class="sep">|</span>
      <span id="current-date">{{ currentDateStr }}</span>
    </div>
    <div class="volume">
      <button id="btn-mute" @click="toggleMute"><AppIcon :name="muted ? 'volume-mute' : 'volume-up'" /></button>
      <input type="range" id="volume" min="0" max="100" :value="volume" @input="setVolume">
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import audioController from '../services/audioController'
import { fmtTime, fmtDate } from '../services/helpers'

export default {
  name: 'AudioPlayer',
  computed: {
    ...mapState(['isPlaying', 'isLive', 'isBuffering', 'currentTime', 'volume', 'muted']),
    // currentTime is updated by App.vue interval when live, so always use it
    currentTimeStr() { return fmtTime(this.currentTime) },
    currentDateStr() { return fmtDate(this.currentTime) }
  },
  methods: {
    toggle() { audioController.toggle() },
    skipBack() { audioController.skip(-30) },
    skipForward() { audioController.skip(30) },
    toggleMute() { audioController.toggleMute() },
    setVolume(e) { audioController.setVolume(parseInt(e.target.value, 10)) },
    skipToNextTrack() { this.$store.dispatch('skipToPreviousTrack') },
    skipToPrevTrack() { this.$store.dispatch('skipToNextTrack') }
  }
}
</script>

<style scoped>
.player-section { display: flex; align-items: center; justify-content: space-between; padding: 16px 24px; background: var(--white); border-bottom: 1px solid var(--gray-200); flex-shrink: 0; }
.transport { display: flex; gap: 8px; flex-shrink: 0; }
.transport button { padding: 10px 16px; border: 1px solid var(--gray-200); border-radius: 4px; background: var(--white); color: var(--gray-600); font-size: 14px; cursor: pointer; transition: all 0.2s; }
.transport button:hover:not(:disabled) { background: var(--gray-50); border-color: var(--gray-300); }
.transport button:disabled { opacity: 0.4; cursor: not-allowed; }
#btn-play { min-width: 50px; }
.time-display { font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; font-size: 14px; font-weight: 500; letter-spacing: -0.01em; color: var(--gray-600); flex-shrink: 0; font-variant-numeric: tabular-nums; }
.time-display .sep { color: var(--gray-300); margin: 0 8px; }
.volume { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.volume button { padding: 8px 12px; border: 1px solid var(--gray-200); border-radius: 4px; background: var(--white); font-size: 14px; color: var(--gray-600); cursor: pointer; transition: all 0.2s; }
.volume button:hover { background: var(--gray-50); }
.volume input[type="range"] { width: 80px; height: 4px; -webkit-appearance: none; background: var(--gray-200); border-radius: 2px; }
.volume input[type="range"]::-webkit-slider-thumb { -webkit-appearance: none; width: 14px; height: 14px; background: var(--gray-800); border-radius: 50%; cursor: pointer; }
</style>
